// Traduções desta tela — coletadas por glob em core/i18n/messages.ts.
export default {
  pt: {
    'dashboard.liveBadge.now': 'agora',
    'dashboard.liveBadge.secondsAgo': 'há {{count}}s',
    'dashboard.liveBadge.minutesAgo': 'há {{count}}min',
    'dashboard.liveBadge.hoursAgo': 'há {{count}}h',
    'dashboard.liveBadge.lastUpdate': 'Última atualização: {{date}}',
    'dashboard.liveBadge.updated': 'atualizado {{relative}}',
  },
  en: {
    'dashboard.liveBadge.now': 'now',
    'dashboard.liveBadge.secondsAgo': '{{count}}s ago',
    'dashboard.liveBadge.minutesAgo': '{{count}}min ago',
    'dashboard.liveBadge.hoursAgo': '{{count}}h ago',
    'dashboard.liveBadge.lastUpdate': 'Last updated: {{date}}',
    'dashboard.liveBadge.updated': 'updated {{relative}}',
  },
  es: {
    'dashboard.liveBadge.now': 'ahora',
    'dashboard.liveBadge.secondsAgo': 'hace {{count}}s',
    'dashboard.liveBadge.minutesAgo': 'hace {{count}}min',
    'dashboard.liveBadge.hoursAgo': 'hace {{count}}h',
    'dashboard.liveBadge.lastUpdate': 'Última actualización: {{date}}',
    'dashboard.liveBadge.updated': 'actualizado {{relative}}',
  },
}
